<template>
  <div class="device-setting">
    <my-header title="选择首页总控设备" back-path="/user"></my-header>
    <div class="container">
      <div class="content">
        <div class="item" v-for="item in itemList" :key="item.name">
          <div class="title" v-text="item.name"></div>
          <div>
            <el-switch v-model="item.checked" active-color="#3AD474" @change="changeSave"></el-switch>
          </div>
        </div>
      </div>
      <div class="remark">
        <img src="@/assets/images/home/zy.png"/>
        <span>选择首页全部设备开/关可以控制的设备，不选择则控制失效。</span>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/HeaderTitle'
import { mapState } from 'vuex'
import basic from '@/model/zone'
import comm from '@/assets/lib/comm'
import { Message } from 'element-ui'

export default {
  name: 'DeviceSetting',
  components: {
    MyHeader
  },
  data () {
    return {
      itemList: [
        { name: '灯具', value: 'light', checked: true },
        { name: '射灯', value: 'spotlight', checked: true },
        { name: '空调', value: 'aircon', checked: true },
        { name: '新风', value: 'airpure', checked: true },
        { name: '风扇', value: 'fan', checked: true },
        { name: '窗帘', value: 'curtain', checked: true },
        { name: '灯带', value: 'colorbar', checked: true },
        { name: '智能插座', value: 'switch', checked: true },
        { name: '智慧空开', value: 'airswitch', checked: true }
      ]
    }
  },
  computed: {
    ...mapState(['zone', 'config'])
  },
  async created () {
    if (!this.zone) {
      await basic.getBasicInfo()
      this.initDevice()
    } else {
      this.initDevice()
    }
  },
  methods: {
    initDevice () {
      if (this.config) {
        this.itemList.forEach(item => {
          if (this.config.map(c => c.key).includes(item.value)) {
            const c = this.config.filter(c => c.key === item.value)[0]
            item.checked = (c.value && true) || false
          }
        })
      }
    },
    async changeSave () {
      // 收集结果，并提交
      const loading = comm.showLoading()
      try {
        const configs = this.itemList.map(i => {
          return { key: i.value, value: i.checked ? 1 : 0, remark: `${i.name}:${i.checked ? '启用' : '禁用'}` }
        })
        await basic.setZoneConfig(this.zone.id, 'controlDevices', JSON.stringify(configs))
        this.$store.commit('SET_CONFIG', configs)
      } catch (e) {
        Message.error('设置失败')
      } finally {
        comm.closeLoading(loading)
      }
    }
  }
}
</script>

<style scoped lang="less">

.device-setting {
  height: 100%;
  display: flex;
  flex-direction: column;
  .container {
    flex: 1;
    position: relative;
    padding: 65px 20px 20px 20px;
    overflow-y: auto;
    & .content {
      border-radius: 4px;
      background-color: white;
      padding: 0px 20px;
      & .item:first-child {
        border: 0px;
      }
      & .item {
        padding: 15px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(220, 220, 220, .5);
        & .title {
          font-size: 17px;
          font-weight: 600;
          color: rgba(34, 34, 34, 1);
        }
      }
    }
    & .remark {
      font-size: 15px;
      font-weight: 400;
      color: rgba(198, 198, 198, 1);
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
      & img {
        width: 18px;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
